import { useMutation } from "@apollo/client";

import { ProjectReviewVisitV2FinalReportRoute_RegenerateSummaryDocument } from "../mutations.generated";

export function useProjectReviewVisitV2FinalReportRoute_RegenerateSummary() {
    const [regenerateSummaryMutation, { data, loading, error }] = useMutation(
        ProjectReviewVisitV2FinalReportRoute_RegenerateSummaryDocument,
    );

    return {
        regenerateSummary: (plannerVisitId: string) => {
            regenerateSummaryMutation({ variables: { input: { plannerVisitId } } }).catch(() => undefined);
        },
        written: data?.plannerVisitRegenerateSummary.written,
        loading,
        error,
    };
}
